import { render } from "./ProfileDropDown.vue?vue&type=template&id=ed97f3a2&scoped=true"
import script from "./ProfileDropDown.vue?vue&type=script&lang=js"
export * from "./ProfileDropDown.vue?vue&type=script&lang=js"

import "./ProfileDropDown.vue?vue&type=style&index=0&id=ed97f3a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed97f3a2"]])

export default __exports__